import React from 'react';
import PieChart from 'components/report-content/components/pie-chart/PieChart';
import PieChartEditPanel from 'components/report-content/components/pie-chart/PieChartEditPanel';
import { AbstractComponentBuilder, ComponentSettingsPieChart } from '@report-content';
export default class PieChartComponentBuilder extends AbstractComponentBuilder<ComponentSettingsPieChart> {
    getComponent() {
        return (
            <PieChart
                updateBlockSettings={this.updateBlockSettings}
                contentSettings={this.contentSettings}
                component={this.block.component}
                actions={this.actions}
            />
        );
    }

    getEditPanel() {
        if (this.contentSettings.context == 'view') {
            return null;
        }
        return (
            <PieChartEditPanel
                block={this.block}
                updateBlockSettings={this.updateBlockSettings}
                contentSettings={this.contentSettings}
                component={this.block.component}
                actions={this.actions}
            />
        );
    }
}
